import axios from "axios";

const API_ROOT =
  (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.trim()) ||
  (window.location.hostname === "localhost" ? "http://localhost:5000" : window.location.origin);


export const api = axios.create({
  baseURL: API_ROOT, // IMPORTANT: no /api here
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
